




































import ArrowIcon from 'frontend/components/icons/ArrowIcon.vue';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';
import { Component, Prop, Vue } from 'vue-property-decorator';

export type LearningPathBadgeParam = Omit<RelatedLearningPathInfo, 'url'> & {
  url?: string;
};

@Component({
  components: { ArrowIcon },
})
export default class LearningPathBadge extends Vue {
  @Prop({ type: Object, required: true })
  private learningPath!: LearningPathBadgeParam;
  @Prop({ type: Boolean })
  private flatBottom?: boolean;
}
